module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD, _vm.USER_ROLES.JOURNEY_MANAGER, _vm.USER_ROLES.SALES_MANAGER]),
      expression: "[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER,USER_ROLES.SALES_MANAGER]",
      modifiers: {
        "if": true
      }
    }]
  }, [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD]),
      expression: "[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-danger mr-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteSiteModal
    }
  }, [_vm._v("Delete Location")])]), _vm._v(" "), _c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.siteName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Location Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.siteName),
      expression: "site.siteName",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "minlength": "3",
      "name": "siteName",
      "required": "",
      "placeholder": "Location Name"
    },
    domProps: {
      "value": (_vm.site.siteName)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.site, "siteName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "siteName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Location name is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Location name is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("Minimum length of Location is 3 character")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.region),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Geographical Area")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.site.region),
      expression: "site.region"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "region"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.site, "region", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Select G.A")]), _vm._v(" "), _vm._l((_vm.region_list), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                                " + _vm._s(item.value) + "\n                                            ")])
  })], 2)]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "region",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Geographical Area is a required field")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.siteType),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Location Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.site.siteType),
      expression: "site.siteType"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "siteType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.site, "siteType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "MS"
    }
  }, [_vm._v("Mother Station")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DBS"
    }
  }, [_vm._v("Daughter Station")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "siteType",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Location Type is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.status),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.site.status),
      expression: "site.status"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "siteType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.site, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "active"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inactive"
    }
  }, [_vm._v("Inactive")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "status",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Status is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.deviceId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Device")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.site.deviceId),
      expression: "site.deviceId"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "deviceId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.site, "deviceId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Device")]), _vm._v(" "), _vm._l((_vm.device_id), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "deviceId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Device is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.salesManager),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Sales Manager")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.site.salesManager),
      expression: "site.salesManager"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "supervisor"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.site, "salesManager", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Select Sales Manager")]), _vm._v(" "), _vm._l((_vm.sales_managers), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "regionRegionManager",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Sales Manager is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.capacity),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Capacity (in SCM)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.capacity),
      expression: "site.capacity",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "max": "9999999",
      "name": "capacity",
      "required": "",
      "placeholder": "Capacity"
    },
    domProps: {
      "value": (_vm.site.capacity)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.site, "capacity", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "capacity",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Capacity is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "min"
    },
    slot: "min"
  }, [_vm._v("Maximum capacity is 9999999")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "dateAdded"
    }
  }, [_vm._v("Commissioning Date")]), _vm._v(" "), _c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.dateAdded),
    attrs: {
      "auto-label": ""
    }
  }, [_c('date-picker', {
    attrs: {
      "required": "",
      "id": "dateAdded",
      "lang": "en",
      "name": "dateAdded",
      "input-class": "form-control",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.site.dateAdded),
      callback: function($$v) {
        _vm.$set(_vm.site, "dateAdded", $$v)
      },
      expression: "site.dateAdded"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "dateAdded",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Commissioning date is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Commissioning date is invalid")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.email),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.email),
      expression: "site.email",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "email",
      "required": "",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.site.email)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.site, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "email",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Email is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Email is invalid")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    attrs: {
      "for": "latitude"
    }
  }, [_vm._v("Latitude")]), _vm._v(" "), _c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.latitude),
    attrs: {
      "auto-label": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.latitude),
      expression: "site.latitude",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "minlength": "2",
      "name": "latitude",
      "required": "",
      "placeholder": "Latitude"
    },
    domProps: {
      "value": (_vm.site.latitude)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.site, "latitude", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "latitude",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Latitude is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Latitude is invalid")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    attrs: {
      "for": "longitude"
    }
  }, [_vm._v("Longitude")]), _vm._v(" "), _c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.longitude),
    attrs: {
      "auto-label": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.longitude),
      expression: "site.longitude",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "minlength": "2",
      "name": "longitude",
      "required": "",
      "placeholder": "Longitude"
    },
    domProps: {
      "value": (_vm.site.longitude)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.site, "longitude", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "longitude",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Longitude is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Longitude is invalid")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.address),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.address),
      expression: "site.address",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "address",
      "maxlength": _vm.maxAddress,
      "required": "",
      "placeholder": "Address"
    },
    domProps: {
      "value": (_vm.site.address)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.site, "address", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "address",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Address is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Address is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "maxlength"
    },
    slot: "maxlength"
  }, [_vm._v("Maximum length is 150 characters")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.siteInfoImage),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Location Image")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "name": "siteInfoImage"
    },
    on: {
      "change": _vm.onFilechanged
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.customerName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Customer Name")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.customerName),
      expression: "site.customerName",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "customerName"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.site, "customerName", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("Think Gas")]), _vm._v(" "), _c('option', [_vm._v("IOCL")]), _vm._v(" "), _c('option', [_vm._v("HPCL")]), _vm._v(" "), _c('option', [_vm._v("BPCL")]), _vm._v(" "), _c('option', [_vm._v("Essar")]), _vm._v(" "), _c('option', [_vm._v("Reliance")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "customerName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Customer Name is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.supervisor),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Location Supervisor(GA Head)")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.site.supervisor),
      expression: "site.supervisor"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "supervisor"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.site, "supervisor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Select GA Head")]), _vm._v(" "), _vm._l((_vm.ga_managers), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "supervisor",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("GA Head is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.dispenserCount),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Dispenser Count")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.dispenserCount),
      expression: "site.dispenserCount",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "max": "25",
      "name": "dispenserCount",
      "placeholder": "Dispenser Count"
    },
    domProps: {
      "value": (_vm.site.dispenserCount)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.site, "dispenserCount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "dispenserCount",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Dispenser Count is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "max"
    },
    slot: "max"
  }, [_vm._v("Maximum Dispenser can be 25")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', {
    staticClass: "col-md-12"
  }, [_vm._v("Owner Details")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.ownerName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Customer Owner Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.site.ownerName),
      expression: "site.ownerName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": _vm.max,
      "required": "",
      "name": "ownerName",
      "placeholder": "Owner Name"
    },
    domProps: {
      "value": (_vm.site.ownerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.site, "ownerName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "ownerName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Owner Name is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "maxlength"
    },
    slot: "maxlength"
  }, [_vm._v("Owner Name should not be more than 20 characters")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.ownerMobile),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Mobile")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.ownerMobile),
      expression: "site.ownerMobile",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "ownerMobile",
      "minlength": "3",
      "name": "ownerMobile",
      "required": "",
      "placeholder": "Owner Mobile"
    },
    domProps: {
      "value": (_vm.site.ownerMobile)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.site, "ownerMobile", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "ownerMobile",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Owner mobile is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.ownerEmail),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Owner Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.ownerEmail),
      expression: "site.ownerEmail",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "minlength": "3",
      "name": "ownerEmail",
      "required": "",
      "placeholder": "Owner Email"
    },
    domProps: {
      "value": (_vm.site.ownerEmail)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.site, "ownerEmail", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "ownerEmail",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Owner Email is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.ownerAddress),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.ownerAddress),
      expression: "site.ownerAddress",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "ownerAddress",
      "minlength": "3",
      "name": "ownerAddress",
      "required": "",
      "placeholder": "Owner Address"
    },
    domProps: {
      "value": (_vm.site.ownerAddress)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.site, "ownerAddress", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "ownerAddress",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Owner Address is a required field")])])], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Sites'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD, _vm.USER_ROLES.JOURNEY_MANAGER]),
      expression: "[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "mr-2 btn gradientbt ",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty)
    },
    on: {
      "click": _vm.updateSite
    }
  }, [_vm._v("Update Location")])], 1)], 1)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-cd88df5e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd88df5e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/site/SiteDetail.vue
// module id = 2384
// module chunks = 0